<template>
    <div class="panel panel-primary" v-show="billingHeaderDataLoaded && billingDataFromStore !== ''">
        <div id="divPrepaySection" v-if="billingDataFromStore.IsPrePay" class="panel-body noform text-center">
            <div id="divDaysRemaining" class="pad-bottom-5">
                <label class="controlLabel">{{ $t("message.daysRemaining") }}</label><br />
                <label class="lbl badge" :style="{color: billingDataFromStore.HeaderBalanceData.DaysRemainingColor, 'background-color': billingDataFromStore.HeaderBalanceData.DaysRemainingBackgroundColor}">
                    {{ billingDataFromStore.HeaderBalanceData.DaysRemaining }}
                </label>
            </div>
            <div id="divDollarsRemaining">
                <label class="controlLabel">{{ $t("message.dollarsRemaining") }}</label><br />
                <label class="lbl" :style="{color: billingDataFromStore.HeaderBalanceData.DollarsRemainingNegativeColor}">
                    {{ handleNegativeNumber($n(billingDataFromStore.HeaderBalanceData.DollarsRemaining, 'currency')) }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import commonJs from '@/common.js';
    export default {
        name: 'BillingSummaryMobile',
        data() {
            return {
                billingHeaderDataLoaded: false
            }
        },
        methods: {
            handleNegativeNumber(num) {
                return commonJs.reformatNumber(num);
            }
        },
        computed: {
            billingDataFromStore() {
                this.billingHeaderDataLoaded = true;

                // Fetch days and dollars remaining (along with colors) from HeaderBalanceData object/CustomerInfo
                return this.$store.getters.getCustomerInfo;
            }
        }
    }
</script>